/**
 * Asynchronously loads the component for SessionMapPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
